import React, { useState } from "react";
import { FaEdit, FaPlusCircle, FaShoppingCart } from "react-icons/fa";
import API from "../../../api.js";
import { showToast } from "../../ToastMessage.jsx";
import { Button, Form } from "react-bootstrap";

const MedicineListTable = ({
  medicines = [],
  loading,
  onEdit,
  onStock,
  onSell,
}) => {
  const [search, setSearch] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [reportLoading, setReportLoading] = useState(false);

  /** --------------------------------------------
   *        Filter Medicines by search text
   * -------------------------------------------*/
  const filtered = medicines.filter((m) => {
    const text = `${m.name} ${m.company} ${m.category}`.toLowerCase();
    return text.includes(search.toLowerCase());
  });

  /** --------------------------------------------
   *       Generate report from merged logic
   * -------------------------------------------*/
  const handleGenerateReport = async () => {
    if (!start || !end) {
      showToast("Please select both start and end dates", "error");
      return;
    }

    try {
      setReportLoading(true);

      const { data } = await API.get("/admin/medicine/report", {
        params: { start, end },
      });

      if (!data?.length) {
        showToast("No sold medicine found in this date range", "warning");
        setReportLoading(false);
        return;
      }

      const totalSold = data.reduce((s, r) => s + r.sold, 0);
      const totalRevenue = data.reduce((s, r) => s + r.revenue, 0);

      const w = window.open("", "_blank");
      w.document.title = "Medicine Sales Report";

      w.document.body.innerHTML = `
        <h2>💊 Medicine Sales Report</h2>
        <p><b>${start}</b> → <b>${end}</b></p>
        <p>Generated: ${new Date().toLocaleString()}</p>

        <table border="1" cellspacing="0" cellpadding="6" width="100%">
          <thead style="background:#f3f3f3;">
            <tr>
              <th>Medicine</th>
              <th>Initial Stock</th>
              <th>Current Stock</th>
              <th>Sold</th>
              <th>Price</th>
              <th>Revenue</th>
            </tr>
          </thead>
          <tbody>
            ${data
              .map(
                (x, i) => `
              <tr style="background:${i % 2 ? "#fafafa" : "white"}">
                <td>${x.name}</td>
                <td>${x.initialStock}</td>
                <td>${x.currentStock}</td>
                <td>${x.sold}</td>
                <td>${x.price}</td>
                <td>${x.revenue}</td>
              </tr>`
              )
              .join("")}
            <tr style="font-weight:bold;background:#e6e6e6;">
              <td colspan="3">Subtotal</td>
              <td>${totalSold}</td>
              <td></td>
              <td>${totalRevenue}</td>
            </tr>
          </tbody>
        </table>
      `;

      w.print();
      setReportLoading(false);
    } catch (err) {
      showToast("Report failed to generate", "error");
      setReportLoading(false);
    }
  };

  return (
    <>
      {/* ----------- TOP FILTER BAR ------------- */}
      <div className="d-flex flex-column flex-md-row gap-3 mb-3">
        {/* Search */}
        <input
          className="form-control"
          placeholder="Search name / company / category…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {/* Date Range for report */}
        <div className="d-flex gap-2">
          <Form.Control
            type="date"
            value={start}
            onChange={(e) => setStart(e.target.value)}
          />
          <Form.Control
            type="date"
            value={end}
            onChange={(e) => setEnd(e.target.value)}
          />
        </div>

        <Button
          variant="primary"
          onClick={handleGenerateReport}
          disabled={reportLoading}
        >
          {reportLoading ? "Generating…" : "Print Report"}
        </Button>
      </div>

      {/* ------------ TABLE WITH SCROLLBAR ------------- */}
      <div
        className="table-responsive shadow-sm"
        style={{
          maxHeight: "480px",
          overflowY: "auto",
          borderRadius: "6px",
        }}
      >
        <table className="table table-hover table-striped align-middle">
          <thead className="table-dark sticky-top">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Company</th>
              <th>Category</th>
              <th>Price</th>
              <th>Stock</th>
              <th>Low Limit</th>
              <th>Sold</th>
              <th style={{ width: "150px" }}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="9" className="text-center">
                  Loading…
                </td>
              </tr>
            ) : filtered.length ? (
              filtered.map((m, i) => (
                <tr
                  key={m._id}
                  className={
                    m.stock <= (m.lowStockLimit ?? 10) ? "table-danger" : ""
                  }
                >
                  <td>{i + 1}</td>
                  <td>{m.name}</td>
                  <td>{m.company}</td>
                  <td>{m.category}</td>
                  <td>Rs {m.price}</td>
                  <td>{m.stock}</td>
                  <td>{m.lowStockLimit ?? 10}</td>
                  <td>{m.sold ?? 0}</td>

                  <td className="d-flex gap-1">
                    {/* <button
                      className="btn btn-sm btn-success"
                      onClick={() => onSell(m)}
                    >
                      <FaShoppingCart />
                    </button> */}
                    <button
                      className="btn btn-warning"
                      onClick={() => onStock(m)}
                    >
                      <FaPlusCircle />
                    </button>
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => onEdit(m)}
                    >
                      <FaEdit />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center">
                  No medicines found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default MedicineListTable;
